module.exports = __webpack_public_path__ + "static/media/Doh.crop.ab6e9def.jpg";